/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, { ReactNode, useContext } from 'react';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import MediaQuery from 'react-responsive';


import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown'
import Accordion from 'react-bootstrap/Accordion'
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import AccordionContext from "react-bootstrap/AccordionContext";

import { IAbsoluteNav22ContainerViewProps } from './absolute-nav22-container';

export const AbsoluteNav22ContainerView: React.FC<IAbsoluteNav22ContainerViewProps> = props => {

    const { 
        
        sh1categories, 
        Shop1List, 
        Shop1ListItem,
        sh2categories, 
        Shop2List, 
        Shop2ListItem,
        sh3categories, 
        Shop3List, 
        Shop3ListItem,
        sh4categories, 
        Shop4List, 
        Shop4ListItem,
        sh5categories, 
        Shop5List, 
        Shop5ListItem,
        sh6categories, 
        Shop6List, 
        Shop6ListItem,
        sh7categories, 
        Shop7List, 
        Shop7ListItem,
        sh8categories, 
        Shop8List, 
        Shop8ListItem,
        tb2categories, 
        Tab2List, 
        Tab2ListItem,
        tb3categories, 
        Tab3List, 
        Tab3ListItem,
        tb4categories, 
        Tab4List, 
        Tab4ListItem,
        tabTitle1,
        tabTitle2,
        tabTitle3,
        tabTitle4
    } = props;

    //@ts-ignore
    const handleSelect = (eventKey) => alert(`selected ${eventKey}`);

    function ContextAwareToggle({ 
        //@ts-ignore
            children, eventKey, callback 
        }) {

            const currentEventKey = useContext(AccordionContext);
            const decoratedOnClick = useAccordionToggle(
              eventKey,
              () => callback && callback(eventKey),
            );
          
            const isCurrentEventKey = currentEventKey === eventKey;
          
            return (
              <button
                type="button"
                className={isCurrentEventKey ? 'accordion-inner active' : 'accordion-inner notactive' }
                onClick={decoratedOnClick}
              >
                {children}
              </button>
            );
        }
    

    
    return (

        <>


            

            <MediaQuery maxWidth={992}>
            <Accordion key='0'>
                <ul className='navBar-mobile'>
                    <li className='navbar-item'>  
                        {/*
                        // @ts-ignore */}
                        <ContextAwareToggle eventKey="0"><span>{tabTitle1}</span></ContextAwareToggle>
                    
                        <Accordion.Collapse className="accordion__content" eventKey="0">
                            <div>

                                {sh1categories ? (
                                    <Module {...Shop1List}>
                                        {sh1categories.map((sh1category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop1ListItem} key={index}>
                                                    {sh1category}
                                                </Node>
                                            );
                                        })}
                                    </Module>
                                ) : null}

                                {sh2categories ? (
                                    <Module {...Shop2List}>
                                        {sh2categories.map((sh2category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop2ListItem} key={index}>
                                                    {sh2category}
                                                </Node>
                                            );
                                        })}
                                    </Module>
                                ) : null}
                                {sh3categories ? (
                                    <Module {...Shop3List}>
                                        {sh3categories.map((sh3category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop3ListItem} key={index}>
                                                    {sh3category}
                                                </Node>
                                            );
                                        })}
                                    </Module>
                                ) : null}
                                {sh4categories ? (
                                    <Module {...Shop4List}>
                                        {sh4categories.map((sh4category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop4ListItem} key={index}>
                                                    {sh4category}
                                                </Node>
                                            );
                                        })}
                                    </Module>
                                ) : null}
                                {sh5categories ? (
                                    <Module {...Shop5List}>
                                        {sh5categories.map((sh5category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop5ListItem} key={index}>
                                                    {sh5category}
                                                </Node>
                                            );
                                        })}
                                    </Module>
                                ) : null}
                                {sh6categories ? (
                                    <Module {...Shop6List}>
                                        {sh6categories.map((sh6category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop6ListItem} key={index}>
                                                    {sh6category}
                                                </Node>
                                            );
                                        })}
                                    </Module>
                                ) : null}
                                {sh7categories ? (
                                    <Module {...Shop7List}>
                                        {sh7categories.map((sh7category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop7ListItem} key={index}>
                                                    {sh7category}
                                                </Node>
                                            );
                                        })}
                                    </Module>
                                ) : null}
                                {sh8categories ? (
                                    <Module {...Shop8List}>
                                        {sh8categories.map((sh8category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop8ListItem} key={index}>
                                                    {sh8category}
                                                </Node>
                                            );
                                        })}
                                    </Module>
                                ) : null}

                            </div>
                        </Accordion.Collapse>
                    </li>

                    {tabTitle2 ? (
                    <li className='navbar-item'>  
                        {/*
                        // @ts-ignore */}
                        <ContextAwareToggle eventKey="2">
                            <span>{tabTitle2}</span>
                        </ContextAwareToggle>
                            
                        <Accordion.Collapse className="accordion__content" eventKey="2">
                            <div>
                                <Module {...Tab2List}>
                                    {tb2categories.map((tb2category: ReactNode, index: number) => {
                                        return (
                                            <Node {...Tab2ListItem} key={index}>
                                                {tb2category}
                                            </Node>
                                        );
                                    })}
                                </Module>
                            </div>
                        </Accordion.Collapse>
                    </li>
                    ) : null}

                    {tabTitle3 ? (
                    <li className='navbar-item'>  
                        {/*
                        // @ts-ignore */}
                        <ContextAwareToggle eventKey="3">
                            <span>{tabTitle3}</span>
                        </ContextAwareToggle>
                            
                        <Accordion.Collapse className="accordion__content" eventKey="3">
                            <div>
                                <Module {...Tab3List}>
                                    {tb3categories.map((tb3category: ReactNode, index: number) => {
                                        return (
                                            <Node {...Tab3ListItem} key={index}>
                                                {tb3category}
                                            </Node>
                                        );
                                    })}
                                </Module>
                            </div>
                        </Accordion.Collapse>
                    </li>
                    ) : null}

                    {tabTitle4 ? (
                    <li className='navbar-item'>  
                        {/*
                        // @ts-ignore */}
                        <ContextAwareToggle eventKey="4">
                            <span>{tabTitle4}</span> 
                        </ContextAwareToggle>
                            
                        <Accordion.Collapse className="accordion__content" eventKey="4">
                            <div>
                                <Module {...Tab4List}>
                                    {tb4categories.map((tb4category: ReactNode, index: number) => {
                                        return (
                                            <Node {...Tab4ListItem} key={index}>
                                                {tb4category}
                                            </Node>
                                        );
                                    })}
                                </Module>
                            </div>
                        </Accordion.Collapse>
                    </li>
                    ) : null}

                </ul>
            </Accordion>
            </MediaQuery>

            <MediaQuery minWidth={992}>
            
            <div className='absolute-nav-tabbed'>

                <Nav activeKey="1" onSelect={handleSelect}>
                    <NavDropdown 
                        title={
                            <div className='testing-testing'>{tabTitle1}</div>
                        } 
                        id="nav-dropdown-1" 
                        className='row align-items-center'
                        menuRole='menu'
                    >
                        <div className='submenu always-flex justify'>
                            <ul className='shopinitial'>
                                <li className="image-holder"></li>
                            </ul>
                            <div className='always-flex ab-flexy justify'>
                                {sh1categories ? (
                                    <Module {...Shop1List}>
                                        {sh1categories.map((sh1category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop1ListItem} key={index}>
                                                    {sh1category}
                                                </Node>
                                            );
                                        })}
                                        <li className="image-holder"></li>
                                    </Module>
                                ) : null}
                                {sh2categories ? (
                                    <Module {...Shop2List}>
                                        {sh2categories.map((sh2category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop2ListItem} key={index}>
                                                    {sh2category}
                                                </Node>
                                            );
                                        })}
                                        <li className="image-holder"></li>
                                    </Module>
                                ) : null}
                            </div>
                            <div className='other-navs'>
                                {sh3categories ? (
                                    <Module {...Shop3List}>
                                        {sh3categories.map((sh3category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop3ListItem} key={index}>
                                                    {sh3category}
                                                </Node>
                                            );
                                        })}
                                        <li className="image-holder"></li>
                                    </Module>
                                ) : null}
                                {sh4categories ? (
                                    <Module {...Shop4List}>
                                        {sh4categories.map((sh4category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop4ListItem} key={index}>
                                                    {sh4category}
                                                </Node>
                                            );
                                        })}
                                        <li className="image-holder"></li>
                                    </Module>
                                ) : null}
                                {sh5categories ? (
                                    <Module {...Shop5List}>
                                        {sh5categories.map((sh5category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop5ListItem} key={index}>
                                                    {sh5category}
                                                </Node>
                                            );
                                        })}
                                        <li className="image-holder"></li>
                                    </Module>
                                ) : null}
                                {sh6categories ? (
                                    <Module {...Shop6List}>
                                        {sh6categories.map((sh6category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop6ListItem} key={index}>
                                                    {sh6category}
                                                </Node>
                                            );
                                        })}
                                        <li className="image-holder"></li>
                                    </Module>
                                ) : null}
                                {sh7categories ? (
                                    <Module {...Shop7List}>
                                        {sh7categories.map((sh7category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop7ListItem} key={index}>
                                                    {sh7category}
                                                </Node>
                                            );
                                        })}
                                        <li className="image-holder"></li>
                                    </Module>
                                ) : null}
                                {sh8categories ? (
                                    <Module {...Shop8List}>
                                        {sh8categories.map((sh8category: ReactNode, index: number) => {
                                            return (
                                                <Node {...Shop8ListItem} key={index}>
                                                    {sh8category}
                                                </Node>
                                            );
                                        })}
                                        <li className="image-holder"></li>
                                    </Module>
                                ) : null}
                                
                            </div>
                        </div>
                    </NavDropdown>
                    {tabTitle2 ? (
                        <NavDropdown 
                            title={tabTitle2} 
                            id="nav-dropdown-2"
                            menuRole='menu'
                        >
                            <Module {...Tab2List}>
                                {tb2categories.map((tb2category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Tab2ListItem} key={index}>
                                            {tb2category}
                                        </Node>
                                    );
                                })}
                            </Module>
                        </NavDropdown>
                    ) : null}
                    {tabTitle3 ? (
                        <NavDropdown 
                            title={tabTitle3} 
                            id="nav-dropdown-3"
                            menuRole='menu'
                        >
                            <Module {...Tab3List}>
                                {tb3categories.map((tb3category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Tab3ListItem} key={index}>
                                            {tb3category}
                                        </Node>
                                    );
                                })}
                            </Module>
                        </NavDropdown>
                    ) : null}
                    {tabTitle4 ? (
                        <NavDropdown 
                            title={tabTitle4} 
                            id="nav-dropdown-4"
                            menuRole='menu'
                        >
                            <Module {...Tab4List}>
                                {tb4categories.map((tb4category: ReactNode, index: number) => {
                                    return (
                                        <Node {...Tab4ListItem} key={index}>
                                            {tb4category}
                                        </Node>
                                    );
                                })}
                            </Module>
                        </NavDropdown>
                    ) : null}
               
                </Nav>

            </div>

            </MediaQuery>
        </>
    );
};

export default AbsoluteNav22ContainerView;